<div (keydown)="onKeyDown($event)" (contextmenu)="onRightClick()" tabindex="0">
<app-preloader></app-preloader>
<app-header-style-four></app-header-style-four>
    <router-outlet></router-outlet>
<app-footer *ngIf="!(location == '/login' || location == '/register' || location == '/coming-soon')"></app-footer>
</div>
